import commonUtil from '../../../../utils/commonUtil';

export const GET_STATE_LIST_LOAD = 'GET_STATE_LIST_LOAD';
export const GET_STATE_LIST_LOAD_SUCCESS = 'GET_STATE_LIST_LOAD_SUCCESS';
export const GET_STATE_LIST_LOAD_FAIL = 'GET_STATE_LIST_LOAD_FAIL';
export const GET_STORE_LIST_LOAD = 'GET_STORE_LIST_LOAD';
export const GET_STORE_LIST_LOAD_SUCCESS = 'GET_STORE_LIST_LOAD_SUCCESS';
export const GET_STORE_LIST_LOAD_FAIL = 'GET_STORE_LIST_LOAD_FAIL';
export const SAVE_STATE_OBJECT = 'SAVE_STATE_OBJECT';

//to show/hide overlay
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';

// to get colorpicker data from content
export const SET_THEME_DATA = 'SET_THEME_DATA';

// to set selected theme uid
export const SET_SELECTED_THEME_UID = 'SET_SELECTED_THEME_UID';

export const SET_SELECTED_IMAGE_1 = 'SET_SELECTED_IMAGE_1';
export const SET_SELECTED_IMAGE_2 = 'SET_SELECTED_IMAGE_2';

export const SET_EVENT_TXT_VALUE = 'SET_EVENT_TXT_VALUE';
export const SET_EVENT_DATE_VALUE = 'SET_EVENT_DATE_VALUE';

export const SET_EVENT_COMMENT = 'SET_EVENT_COMMENT';

export const CLEAR_EVENT_PERSONALIZATION = 'CLEAR_EVENT_PERSONALIZATION';

export function isGetStateListLoaded(globalState) {
  return globalState.createEvent.dataState && globalState.createEvent.loaded;
}

export function getStateList() {
  const userData = {};
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  userData.searchType = 'preferredStore';
  return {
    types: [GET_STATE_LIST_LOAD, GET_STATE_LIST_LOAD_SUCCESS, GET_STATE_LIST_LOAD_FAIL],
    promise: client => client.post('/api/stateList', {
      data: (userData),
    }),
  };
}

export function isGetStoreListLoaded(globalState) {
  return globalState.createEvent.dataStore && globalState.createEvent.loaded;
}

export function getStoreList(stateId) {
  const userData = {};
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  userData.stateId = stateId;
  userData.searchType = 'preferredStore';
  return {
    types: [GET_STORE_LIST_LOAD, GET_STORE_LIST_LOAD_SUCCESS, GET_STORE_LIST_LOAD_FAIL],
    promise: client => client.post('/api/storeList', {
      data: (userData),
    }),
  };
}

export function validateEventName(ownerEmail, eventName) {
  const _eventNamevalidation = {};
  _eventNamevalidation.brand = commonUtil.getBrand();
  _eventNamevalidation.channel = commonUtil.getChannel().toUpperCase();
  _eventNamevalidation.ownerEmail = ownerEmail;
  _eventNamevalidation.eventName = eventName;
  return commonUtil.triggerServerRequest({ url: '/api/validateEventName', method: 'POST', data: _eventNamevalidation });
}

export function getSaveStateData(pageName, eventData, stateData) {
  return {
    type: SAVE_STATE_OBJECT,
    data: stateData,
  };
}

export const defineStoreListData = (stateId) => {
  const _m = stateId;
  return (dispatch) => {
    dispatch(getStoreList(_m));
  };
};


export const showOverlay = () => ({
  type: SHOW_OVERLAY,
});

export const hideOverlay = () => ({
  type: HIDE_OVERLAY,
});


export const setThemeData = (themes) => ({
  type: SET_THEME_DATA,
  payload: themes,
});


export const setSelectedThemeUid = (uid) => ({
  type: SET_SELECTED_THEME_UID,
  payload: uid,
});

export const setSelectedImage1 = (imageUrl) => ({
  type: SET_SELECTED_IMAGE_1,
  payload: imageUrl,
});

export const setSelectedImage2 = (imageUrl) => ({
  type: SET_SELECTED_IMAGE_2,
  payload: imageUrl,
});

export const setEventComment = (comment) => ({
  type: SET_EVENT_COMMENT,
  payload: comment,
});

export const setEventTxtValue = (txt) => ({
  type: SET_EVENT_TXT_VALUE,
  payload: txt,
});

export const setEventDateValue = (date) => ({
  type: SET_EVENT_DATE_VALUE,
  payload: date,
});

export const clearEventPersonalization = () => ({
  type: CLEAR_EVENT_PERSONALIZATION,
});